import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "textarea"]

  open(event) {
    event?.preventDefault()
    if (!this.hasPanelTarget) return
    this.panelTarget.hidden = false
    this.textareaTarget?.focus()
  }

  close(event) {
    event?.preventDefault()
    if (!this.hasPanelTarget) return
    this.panelTarget.hidden = true
  }
}
